import SntNavbar from './SntNavbar.vue'

export { SntNavbar }
export default {
  $_shipnity_subcomponents: {
    SntNavbar
  }
}
